<template>
  <layout-basic>
    <h3 class="title is-4">Import</h3>

    <div class="notification is-danger is-light m-2 p-2" v-for="message of importWarningMessages">{{ message }}</div>
    <div class="notification is-success is-light m-2 p-2" v-for="message of importSuccessMessages">{{ message }}</div>

    <form v-on:submit="importFormSubmit" enctype="multipart/form-data">
      <br>
      <section>
        <b-field class="file is-primary" :class="{'has-name': !!importForm.file}">
          <b-upload v-model="importForm.file" class="file-label">
            <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Select the json file to import</span>
            </span>
            <span class="file-name" v-if="importForm.file">
                {{ importForm.file.name }}
            </span>
          </b-upload>
        </b-field>
      </section>

      <br>

      <button class="button is-primary">Import</button>
    </form>

    <a id="downloadAnchorElem"></a>
  </layout-basic>

</template>
<script>

import LayoutBasic from '@/layouts/LayoutBasic'
import SystemService from '@/services/SystemService'

export default {
  name: 'Projects',
  components: {
    LayoutBasic
  },
  created() {

  },
  data() {
    return {
      files: [],
      importSuccessMessages: [],
      importWarningMessages: [],
      importForm: {
        file: null
      }
    }
  },

  methods: {
    importFormSubmit(e) {
      let formData = new FormData();
      formData.append('file', this.importForm.file);

      SystemService.import(formData).then(response => {
        if (response.data.warningMessages) {
          this.importWarningMessages = response.data.warningMessages;
          this.importSuccessMessages = response.data.successMessages;
        }
      })
      e.preventDefault();
    }
  }
}
</script>
